import "/static/styles/styles.css";
import * as React from 'react';
export default {
  React
};